import styled from '@emotion/styled';

import type { PixelProps } from '../../type';

export const TreeLayerWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #1f1f23;
  border-radius: 4px;
  gap: 2px;
  background-color: #1f1f23;
`;

export const Row = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 11px;
  width: 100%;
  gap: 2px;
`;

export const Pixel = styled.div<PixelProps>`
  border-radius: 1px;
  width: 10px;
  height: 10px;
  z-index: 1;
  background-color: ${({
    type,
    layerConfig,
    isVisible,
    isUserContribution,
  }) => {
    if (!isVisible) {
      return 'transparent';
    }

    if (isUserContribution) {
      switch (type) {
        case 'B':
          return `
            border-radius: 1px;
            border: 3px solid rgba(255, 255, 0, 0.80);
            background: #F43D3A;
            z-index: 3;
          `;
        case 'S':
          return `
            border-radius: 1px;
            border: 3px solid rgba(255, 255, 0, 0.80);
            background: #273261;
            z-index: 3;
          `;
        case 'G':
          return `
            border-radius: 1px;
            border: 3px solid rgba(255, 255, 0, 0.80);
            background: #fff;
            z-index: 3;
          `;
        case 'L':
          return `
            border-radius: 1px;
            border: 3px solid rgba(255, 255, 0, 0.80);
            background: #16c174;
            z-index: 3;
          `;
        case 'T':
          return `
            border-radius: 1px;
            border: 3px solid rgba(255, 255, 0, 0.80);
            background: #07735c;
            z-index: 3;
          `;
        default:
          return `
            border-radius: 1px;
            border: 3px solid rgba(255, 255, 0, 0.80);
            background: #483b3b;
            z-index: 3;
          `;
      }
    }

    const color = layerConfig.baseColors[type];
    const opacity = layerConfig.opacity;
    if (color.startsWith('#')) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    return color;
  }};
`;
